<template>
  <base-popup v-if="show" @close="$emit('close')" popupStyle="alert">
    <template #header>
      <h3>Confirmer la suppression</h3>
    </template>
    <template #bodyContent>
      Êtes-vous sûr de vouloir supprimer "{{ elementName }}" ?
    </template>
    <template #footer>
      <button @click="$emit('close')" class="cancel-button">
        Annuler
      </button>
      <button @click="$emit('confirm')" class="confirm-button">
        Supprimer
      </button>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from './Base/BasePopup.vue'

export default {
  name: 'DeleteConfirmPopup',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    elementName: {
      type: String,
      required: true
    }
  },
  components: {
    BasePopup
  }
}
</script>

<style scoped>
.cancel-button {
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.375rem;
  color: #e5e7eb;
  font-weight: 500;
  transition: all 0.2s ease;
}

.cancel-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.confirm-button {
  padding: 0.5rem 1rem;
  background-color: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 0.375rem;
  color: #ef4444;
  font-weight: 500;
  transition: all 0.2s ease;
}

.confirm-button:hover {
  background-color: rgba(239, 68, 68, 0.3);
  border-color: #ef4444;
}
</style> 